import React, {useCallback, useContext, useEffect, useState} from 'react';
import CardView from './CardView';
import NoContent from './common/components/NoContent';
import NoFilterIcon from '../assests/img/no-filter.svg?react';
import ContentHeader from './common/components/ContentHeader';
import {FilterContext, favouriteType} from './common/context/filterContext';
import {getCarrierData, getFilterData} from './common/api/getApiData';
import {CardContext} from './common/context/cardContext';
import {formatCarrierData} from './common/functions/formatData';
import {cardType} from './common/components/Card';
import {contructFavouritesQuery, contructGetFilterQuery} from './common/functions/contructQuery';
import Pagination from './common/components/Pagination';
import {itemsPerPage} from '../constants/options';
import {updateDataApi, updateCompanyDetail} from './common/api/updateApi';
import AddCard from './AddCard';
import AddIcon from '../assests/img/add-icon.svg?url';
import Loader from './common/components/Loader';
import {UserContext} from './common/context/userContext';
import {getUserPermisson} from './common/functions/utils';
import {AuthContext} from './common/context/authContext';
import '../assests/css/content.scss';

export enum updateField {
    'notes',
    'underwriter',
    'name',
    'distribution',
    'type',
    'minimumTiv',
    'mnimumCms',
    'coverage',
    'facilityType',
    'uniqueReq',
    'submissionReq',
    'refreshData',
    'contactId',
    'category',
    'logo'
}

export interface contentProps {
    showWholesalers: boolean,
    onWholesalersSelect: (selected: boolean)=> void,
}

export default function Content(props: contentProps) {

    const {showWholesalers, onWholesalersSelect} = props;
    const [cardData, setCardData] = useState<cardType[]>([]);
    const {filterContent, filterData, setFilterData} =
        useContext(FilterContext);
    const [filterApplied, setFilterApplied] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [addNew, setAddNew] = useState(false);
    const [resetCurrentPage, setResetCurrentPage] = useState(false);
    const [homePageNumber, setHomePageNumber] = useState(0);
    const [groupIdSelected, setGroupIdSelected] = useState(0);
    const {data: {permissions, userId}} = useContext(UserContext);
    const {accounts} = useContext(AuthContext);

    const isFavourite = (groupId: number) => {
        if (filterData.favourites) {
            const temp  = [...filterData.favourites];
            const index = temp.findIndex((data: favouriteType)=>
                data.companyGroupId === groupId);
            if (index >= 0) {
                return groupId;
            } else {
                return false;
            }
        }
    }

    const getFormattedCardData = async (query: string) => {
        const data = await getCarrierData(query, accounts);
        if (filterData.carrier.length) {
            const formattedCardData = formatCarrierData(data,
                filterData.carrier, filterData.contacts,
                filterData.facilityType, filterData.coverage,
                filterData.categories, filterData.companyCategories);
            return formattedCardData;
        } else {
            return [];
        }
    }

    const getCardData = useCallback(async () => {
        setLoading(true);
        const {query, filterQuery, filterCount} =
            contructGetFilterQuery(filterContent);

        if (query.length && filterCount) {
            setFilterApplied(true);
            let formattedCardData = await
                getFormattedCardData(filterQuery);
            if (filterContent.favourites !== null &&
                    filterContent.favourites.length) {
                formattedCardData = formattedCardData.filter((data: any)=>
                    data.groupId === isFavourite(data.groupId));
            }
            setCardData(formattedCardData);
        } else {
            if (filterContent.favourites !== null &&
                filterContent.favourites.length) {
                const {favouritesQuery} =
                    contructFavouritesQuery(filterContent.favourites);
                const formattedCardData = await
                    getFormattedCardData(favouritesQuery)
                setCardData(formattedCardData);
            } else {
                setFilterApplied(false);
                setCardData([]);
            }
        }

        setLoading(false);
    }, [
        filterContent, filterData.coverage, filterData.facilityType,
        filterData.carrier, filterData.contacts, filterData.categories,
        filterData.companyCategories, filterContent.favourites
    ]);

    const handleUpdate = async (reqBodyParam: any, field: updateField,
        endpoint?: string) => {
        const reqBody = {...reqBodyParam,
            UpdatedDateTime: new Date().toISOString(),
            UpdatedById: userId}
        if (field === updateField.notes) {
            const status = await updateCompanyDetail(reqBody, accounts);
            const groupId = reqBody.fieldId;
            if (status === 200) {
                const temp = [...cardData];
                temp.map((eachData)=> {
                    if (eachData.groupId === groupId) {
                        eachData.notes = reqBody.fieldValue;
                    }
                    return eachData;
                })
            }
            return status;
        }

        if (field === updateField.minimumTiv ||
                field === updateField.mnimumCms) {
            const res = await updateCompanyDetail(reqBody, accounts);
            return res;
        }

        if (field === updateField.coverage) {
            const res = await updateCompanyDetail(reqBody, accounts);
            return res;
        }

        if (field === updateField.name) {
            const res = await updateDataApi(endpoint? endpoint: 'Company', reqBody,
                accounts);
            return res;
        }

        if (field === updateField.distribution || field === updateField.type) {
            const res = await updateDataApi(endpoint? endpoint: 'Company', reqBody,
                accounts);
            return res;
        }

        if (field === updateField.uniqueReq) {
            const res = await updateCompanyDetail(reqBody, accounts);
            return res;
        }

        if (field === updateField.underwriter) {
            const status = await updateDataApi(endpoint? endpoint: 'Contact',
                reqBody, accounts);
            return status;
        }

        if (field === updateField.refreshData) {
            setLoading(true);
            let carriers = filterData.carrier;
            let contacts = filterData.contacts;
            let companyCategories = filterData.companyCategories;
            if (reqBody.data.includes('h')) {
                carriers = await getFilterData('GetCarriers', accounts, true);
            }
            if (reqBody.data.includes('c')) {
                companyCategories = await getFilterData('CompanyCategory', accounts,
                    false);
            }
            if (reqBody.data.includes('u')) {
                contacts = await getFilterData('GetContacts', accounts, false);
            }
            setFilterData({...filterData, companyCategories: companyCategories,
                contacts: contacts, carrier: carriers}, 'ccc');
        }

        if (field === updateField.contactId) {
            const res = await updateCompanyDetail(reqBody, accounts);
            return res;
        }

        if (field === updateField.submissionReq) {
            const res = await updateCompanyDetail(reqBody, accounts);
            return res;
        }

        if (field === updateField.logo) {
            const res = await updateDataApi(endpoint? endpoint: 'Company', reqBody,
                accounts);
            return res;
        }

    }

    const setCurrentPageFunc = (page: number) => setCurrentPage(page);

    const getStartEndIndices = () => {
        const start = currentPage === 1? 0: (currentPage-1) * itemsPerPage;
        const end = currentPage === 1? itemsPerPage: start + (itemsPerPage);
        return [start, end];
    }

    const paginatedCardData = (cardData: cardType[]) => {
        if (cardData.length<=6) {
            return cardData;
        } else {
            const [start, end] = getStartEndIndices();
            const cardDataPaginated = cardData.slice(start, end);
            return cardDataPaginated;
        }
    }

    const getTotalPages = () =>
        cardData.length<=itemsPerPage? 1:
            Math.ceil(cardData.length / itemsPerPage);

    
    const handleWholesalersSelected = (selecetd: boolean) => {
        if (selecetd === true) {
            setResetCurrentPage(()=> false);
            setHomePageNumber(()=> currentPage);
        } else {
            setResetCurrentPage(()=> true);
        }
        onWholesalersSelect(selecetd);
    }

    const handleOnAddNewCard = async () => {
        setLoading(true);
        let carriers = filterData.carrier;
        let contacts = filterData.contacts;
        carriers = await getFilterData('GetCarriers', accounts, true);
        contacts = await getFilterData('GetContacts', accounts, false);
        setFilterData({...filterData,
            contacts: contacts, carrier: carriers}, 'cc');
    }

    useEffect(()=> {
        getCardData();
    }, [
        getCardData,
    ]);

    useEffect(()=> {
        setCurrentPage(showWholesalers === true? 1:
            resetCurrentPage? homePageNumber: 1);
        setResetCurrentPage(false);
    }, [
        filterContent,
    ]);

    return (
        <CardContext.Provider value={{data: cardData,
            carrier: filterData.carrier,
            contact: filterData.contacts}}>
            <div className="content-container home-container">
                <ContentHeader title={showWholesalers? 'Wholesalers': 'Home'}
                    count={cardData.length} showDownload={true}
                    showAdd={getUserPermisson(permissions, 'C')}
                    showWholesalers={showWholesalers}
                    onWholesalersSelect={(selected) =>
                        handleWholesalersSelected(selected)}
                    ctaProps={{
                        buttonText: 'Add',
                        onClick: () => setAddNew(true),
                        type: 'primary-outline',
                        buttonIconUrl: AddIcon,
                    }}
                    showSort={true}/>
                {getUserPermisson(permissions, 'C')?
                <AddCard showPopup={addNew} closePopup={() =>
                    setAddNew(false)}
                    onAddNewCard={handleOnAddNewCard}/>: null}
                {!loading? cardData.length?
                <>
                    <CardView data={paginatedCardData(cardData)}
                        handleUpdate={(reqBody: any, field: updateField,
                            endpoint?: string)=>
                            handleUpdate(reqBody, field, endpoint)}
                        onWholesalersSelect={(selected)=>
                            handleWholesalersSelected(selected)}
                        onGroupIdSelected = {(id)=>
                            setGroupIdSelected(id)}
                        groupIdSelected={groupIdSelected}
                        />
                    <Pagination
                        totalPages={getTotalPages()}
                        currentPage={currentPage}
                        setCurrentPage={(page)=> setCurrentPageFunc(page)}
                        pageStatusText={cardData.length<=itemsPerPage?
                            `Showing ${cardData.length} item(s)` :
                            `Showing ${itemsPerPage.toString()} items per page of \n
                                ${cardData.length} items`}
                        />
                </>
                : 
                <NoContent
                    textToDisplay={filterApplied === true ? 'No results for the selecetd filter(s)': 'Apply filters from the left panel to list carriers'}
                    cta={<></>}
                    showIcon={true}
                    mainImage={<NoFilterIcon width={"298"} height={"295"}/>}
                />:
                <Loader/>}
            </div>
        </CardContext.Provider>
    );

}